export default {
  getBusiness(state) {
    return state.business;
  },
  getBusinessCurrency(state) {
    return state.businessCurrency;
  },
  getLandingPage(state) {
    return state.landingPage;
  },
  getLandingPages(state) {
    return state.landingPages;
  },
  getEcommerce(state) {
    return state.ecommerce;
  },
  getEmbedForm(state) {
    return state.embedForm;
  },
  getEmbedForms(state) {
    return state.embedForms;
  },
  getLinkPage(state) {
    return state.linkPage;
  },
  getLinkPages(state) {
    return state.linkPages;
  },
  getCustomForm(state) {
    return state.customForm;
  },
  getCustomForms(state) {
    return state.customForms;
  },
  getSpecialFields(state) {
    return state.specialFields;
  },
  getFaq(state) {
    return state.faq;
  },
  getFaqs(state) {
    return state.faqs;
  },
};
